import React, { useState, useCallback } from 'react';
import { Table } from 'semantic-ui-react';
import IndexRow from './IndexRow.jsx';

export default function IndexPage(props) {
  const [filters, setFilters] = useState([...props.filters]);
  const onSave = useCallback(
    (idx, filter) => {
      const newFilters = [...filters];

      newFilters[idx] = filter;
      setFilters(newFilters);
    },
    [filters],
  );

  return (
    <Table striped>
      <Table.Body>
        {filters.length === 0 ? (
          <Table.Row>
            <Table.Cell textAlign='center'>No Filters Created</Table.Cell>
          </Table.Row>
        ) : (
          filters.map((filter, idx) => {
            return (
              <IndexRow
                key={filter.id}
                canDestroyFilter={props.canUpdateFilter}
                canUpdateFilter={props.canUpdateFilter}
                filter={filter}
                link={props.link}
                onSave={(e) => onSave(idx, e)}
              />
            );
          })
        )}
      </Table.Body>
    </Table>
  );
}
